import { useState } from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import { useAccount, useMsal } from '@azure/msal-react';


const ChangeLogForm = (props: { modalRef: any,
     saveEvent: any, tabName: string}) => {

    const [comment, setComment] = useState("");
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0] || {});

    const valueChangeHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setComment(event.target.value)
    }

    const closeChangeLogModal = () => {
        props.modalRef.current?.click();
    }

    const handleSubmit =  (e: React.FormEvent) => {
        e.preventDefault();
        const form = e.target as HTMLFormElement;
        
        let completed:any =  props.saveEvent(e, {
            comment: (form.elements[0] as HTMLTextAreaElement).value,
            username: account?.username
        });
        
        if (completed) {
            closeChangeLogModal();
            setComment("");
        }

    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col col-12 mb-2">
                        <label htmlFor="comment" className="form-label">Comment:</label>
                        <textarea
                            name="comment"
                            id="comment"
                            className="form-control"
                            value={comment}
                            onChange={valueChangeHandler}
                            rows={3}
                            placeholder="Comment on the changes made"
                        />

                    </div>


                    <div className="col col-6 mb-2 d-grid">
                        <button disabled={false} type="submit" className="btn btn-success">
                            <span className="fs-5 text-white">
                                <IoCheckmarkCircleOutline />
                            </span> Submit
                        </button>
                    </div>

                    <div className="col col-6 mb-2 d-grid">
                        <button disabled={false} type="button" className="btn btn-warning" onClick={(e) => {
                            setComment("");
                            closeChangeLogModal();
                        }}>
                            <span className="fs-5">
                                <RxCrossCircled />
                            </span> Cancel
                        </button>
                    </div>
                </div>

            </form>
        </>
    );
}
export default ChangeLogForm